import { App } from 'vue';

import VueDOMPurifyHTML from 'vue-dompurify-html';

const install = (app: App) => {
  app.use(VueDOMPurifyHTML, {
    default: {
      FORBID_ATTR: ['style'],
    },
  });
};

export { install };
